import React from "react";
import Signup from "../components/Auth/Signup";

function SignupPage() {
  return (
    <div>
      <Signup />
    </div>
  );
}

export default SignupPage;
